import Repository from './repository';

const resource = '/user';
export default {
	byid(id) {
		return Repository.getWithAuth(`${resource}/${id}`);
	},

	find(payload) {
		return Repository.postWithAuth(`${resource}/find`, payload);
	},

	add(payload) {
		return Repository.postWithAuth(`${resource}`, payload);
	},
	// Starts an email change. Nothing changes until the link mailed to the new
	// address is followed; that lands on the public confirm route, not here.
	requestEmailChange(payload) {
		return Repository.postWithAuth(`${resource}/email/update`, payload);
	},

	update(payload, user_id) {
		return Repository.putWithAuth(`${resource}/${user_id}`, payload);
	},

	updateRole(payload, user_id) {
		return Repository.putWithAuth(`${resource}/role/${user_id}`, payload);
	},

	updateBlockUser(payload, user_id) {
		return Repository.putWithAuth(`${resource}/block/${user_id}`, payload);
	},

	updatePassword(payload, user_id) {
		return Repository.putWithAuth(`${resource}/password/${user_id}`, payload);
	},

	delete(id) {
		return Repository.deleteWithAuth(`${resource}/${id}`);
	},
};
